export default {
  cancel: 'Cancel',
  ok: 'OK',
}